import React, { Component, createRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { Bar } from "react-chartjs-2";
import { Row, Col } from "reactstrap";
import moment from "moment";
import "./styles/dailySummary.css";
import "./styles/mealPlanner.css";
import "./styles/dailySummaryModern.css";
import dailyInputSummaryActions from "../actions/dailyInputSummaryActions";
import { getLoggedInUser } from "../services/AuthenticationService";
import { Loading, DateTimePicker, RichDropdown } from "../components";
import { checkMarker } from "../lib/helper";

const calculateYAxisTicks = (valuesArray) => {
  const multiple = 2;

  const values = (valuesArray || [])
    .map(v => Number(v))
    .filter(v => Number.isFinite(v));

  if (!values.length) return [0, 1, 2, 3, 4, 5];

  const minVal = Math.min(...values);
  const maxVal = Math.max(...values);

  const paddedMax = maxVal + 1.0;
  const start = minVal === 0 
    ? 0 
    : Math.floor((minVal - 1.0) / multiple) * multiple;

  const end = Math.ceil(paddedMax / multiple) * multiple;

  if (!Number.isFinite(end) || end <= start) return [0, 1, 2, 3, 4, 5];

  const interval = (end - start) / 4;

  const ticks = [];
  for (let i = 0; i <= 4; i++) {
    ticks.push(Math.round(start + interval * i));
  }
  ticks.push(Math.round(end));

  return ticks;
};
class DailyInputSummary extends Component {
  constructor(props) {
    super(props);
    this.exp = createRef();
    this.ing = createRef();
    this.state = {
      user_id: "",
    };
  }
  async componentDidMount() {
    this.loggedInUser = await getLoggedInUser();
    this.userLang = this.loggedInUser.lang;
    await this.props.getDailySummaryUsers(this.loggedInUser._id);
    let startdate = moment().startOf("day").unix() * 1000;
    await this.props.initialize(startdate, this.loggedInUser._id);
  }

  changeUser(e) {
    let userId = e.target ? e.target.value : e._id;
    let user = this.props.users.filter((user) => {
      return user._id == userId;
    });
    let userGroup = user.length > 0 ? user[0].group : "";
    this.props.selectUser(userId, userGroup);
    let startDate = moment().startOf("day").unix() * 1000;
    this.props.initialize(startDate, userId);
  }

  onDateChange(e) {
    let selectedId = this.props.selectedId;
    let startDate = moment(e).startOf("day").unix() * 1000;
    this.props.onDateChange(e);
    if (this.props.selectedDate !== startDate) {
      this.props.initialize(startDate, selectedId);
    }
  }
  scrollToTop() {
    this.exp.current.scrollTo({ top: 0, behavior: "smooth" });
    this.ing.current.scrollTo({ top: 0, behavior: "smooth" });
  }

  render() {
    const {
      nutritionsList,
      intakes,
      burnt,
      users,
      // food,
      pcp,
      activity,
      medication,
      isLoading,
      mealListAll,
      location,
      temperature,
      humidity,
      windSpeed,
      PM25,
      PM10,
      Ozone,
      NitrogenDioxide,
      CarbonMonoxide,
      SulfurDioxide,
      USEPAAQI,
      PrimaryPollutantEPA,
      HealthConcernEPA,
      ChinaMEPAQI,
      PrimaryPollutantMEP,
      HealthConcernMEP,
      PollenIndexforTrees,
      t,
    } = this.props;

    const yTicks = calculateYAxisTicks([...(burnt || []), ...(intakes || [])]);
    const yMin = Math.min(...yTicks);
    const yMax = Math.max(...yTicks);
    const stepSize = yTicks.length > 1 ? (yTicks[1] - yTicks[0]) : undefined;

    const data = {
      labels: [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        t("dailySummary.TTL_GRAPH_TEXT"),
      ],
      datasets: [
        {
          label: this.props.t("dailySummary.BURNT_LABEL"),
          data: burnt,
          backgroundColor: "#2E79C4",
        },
        {
          label: this.props.t("dailySummary.INTAKE_LABEL"),
          data: intakes,
          backgroundColor: "#F79028",
        },
      ],
    };

    const titleTooltip = (tooltipItems) => {
      return "";
    };
    const options = {
      tooltips: {
        callbacks: {
          title: titleTooltip,
        },
      },
      responsive: true,
      legend: { display: false },
      layout: {
        padding: {
          left: 16,
          right: 15,
        },
      },
      scales: {
        xAxes: [
          {
            ticks: {
              fontSize: 10,
              fontColor: "white",
              fontStyle: "bold",
              maxRotation: 45,
              minRotation: 45,
            },
          },
        ],
        yAxes: [
          {
            gridLines: {
              color: "#191919",
            },
            ticks: {
              fontSize: 9,
              fontStyle: "bold",
              fontColor: "white",

              // ✅ force same range
              min: yMin,
              max: yMax,

              // ✅ force same spacing
              stepSize: stepSize,
            },
          },
        ],
      },
      maintainAspectRatio: false,
    };

    return (
      <div
        className=" daily-black-container daily-summary-modern "
        style={{ display: "flex", flexDirection: "column" }}
      >
        <Loading isLoading={isLoading} />

        {/* user and date picker area */}

        <Row
          className="daily-summary-dropdown"
          style={{ color: "black", marginLeft: "1.5px" }}
        >
          <Col>
            <RichDropdown
              name="user"
              input={{
                name: "user",
                value: this.props.selectedId,
                onChange: (e) => {
                  this.changeUser(e);
                  this.scrollToTop();
                },
              }}
              options={
                users
                  ? users.map((u) => ({
                      value: u._id,
                      label: `${u.first_name} ${u.last_name}`,
                    }))
                  : []
              }
              disabled={false}
              t={this.props.t}
            />

          </Col>

          <Col xs="5">
            <div id="daily_date_picker">
              <DateTimePicker
                placeholder={t("general.DATE_PICKER_TEXT")}
                value={this.props.today ? "" : this.props.startDate}
                onChange={(e) => {
                  this.onDateChange(e), this.scrollToTop();
                }}
                dateFormat="DD MMM YYYY"
                timeDisable="true"
                disableFutureDates={true}
                dark={true}
                dailyAndAnalyze={true}
              />
            </div>
          </Col>
        </Row>

        {/* bar chart area */}

        <div className="bar-chart-area">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
            }}
          >
            <div style={{ marginBottom: "5px" }}>
              <h6 style={{ position: "absolute" }} className="section-title">
                {t("dailySummary.CALORY_TEXT")}
              </h6>
              <div style={{ marginLeft: "5rem", marginTop: "2px" }}>
                <i
                  className="fas fa-square"
                  style={{
                    color: "#2E79C4",
                    fontSize: "12px",
                    marginLeft: "10px",
                  }}
                ></i>
                <span style={{ fontSize: "14px", marginLeft: "5px" }}>
                  {t("dailySummary.BURNT_LABEL")}
                </span>
                <i
                  className="fas fa-square"
                  style={{
                    color: "#F79028",
                    fontSize: "12px",
                    marginLeft: "20px",
                  }}
                ></i>
                <span style={{ fontSize: "14px", marginLeft: "5px" }}>
                  {t("dailySummary.INTAKE_LABEL")}
                </span>
              </div>
            </div>
          </div>
          <div id="canvas-container">
            <Bar data={data} options={options} />
          </div>
        </div>

        {/* exposure section area */}
        <h6 className="section-title">
          {t("dailySummary.EXPOSURE_SECTION_TITLE")}
        </h6>

        <div
          className={`grayList ingredient-list`}
          style={{
            flex: 1,
            backgroundColor: "black",
            borderColor: "#5c5c5c",
            height: "100%",
            padding: "1.5px 0.5rem",
          }}
          ref={this.exp}
        >
          <div className={`exposure-section exposure-content`}>
            <div className="exposure-category">
              <p>
                <span className="category-title">
                  {t("dailySummary.EXPOSURE_FOOD_TEXT")}
                </span>
                {/* {food} */}
                {Array.isArray(mealListAll) && mealListAll.length > 0
                  ? mealListAll.map((item, i) => {
                      const contributedItem = item.is_contribute || false;
                      // const hasC = item.ingredient.slice(-3) === "(C)" || item.ingredient.slice(-4) === "(CR)";
                      const hasC = checkMarker(item.ingredient, "C") || checkMarker(item.ingredient, "CR");
                      const foodText =
                        (contributedItem || hasC) && item.ingredient.length > 30
                          ? `${item.ingredient.substr(0, 30)}...`
                          : item.ingredient;

                      const isLast = i === mealListAll.length - 1;
                      const suffix =
                        isLast && this.userLang === "1200000000001000022"
                          ? "."
                          : isLast && this.userLang !== "1200000000001000022"
                          ? "。"
                          : ", ";

                      return (
                        <span key={i}>
                          <span
                            style={{
                              color: item.allergy ? "#F44336" : "#ffffff",
                              fontWeight: item.allergy ? "bold" : "normal",
                            }}
                          >
                            {foodText}
                          </span>
                          <span
                            style={{
                              color: "white",
                              fontWeight: "normal",
                            }}
                          >
                            {suffix}
                          </span>
                        </span>
                      );
                    })
                  : t("dailySummary.NONE_EXPOSURE_TEXT")}
                {this.props.supplements ? this.props.supplements : ""}

              </p>
            </div>
            <div className="exposure-category">
              <p>
                <span className="category-title">
                  {t("dailySummary.EXPOSURE_PCP_TEXT")}
                </span>
                {Array.isArray(pcp) && pcp.length > 0
                  ? pcp.map((item, i) => {
                      const contributedItem = item.is_contribute || false;
                      // const hasC = item.ingredient.slice(-3) === "(C)" || item.ingredient.slice(-4) === "(CR)";
                      const hasC = checkMarker(item.ingredient, "C") || checkMarker(item.ingredient, "CR");
                      const pcpText =
                        (contributedItem || hasC) && item.ingredient.length > 30
                          ? `${item.ingredient.substr(0, 30)}...`
                          : item.ingredient;

                      const isLast = i === pcp.length - 1;
                      const suffix =
                        isLast && this.userLang === "1200000000001000022"
                          ? "."
                          : isLast && this.userLang !== "1200000000001000022"
                          ? "。"
                          : ", ";

                      return (
                        <span key={i}>
                          <span
                            style={{
                              color: item.allergy ? "#F44336" : "#ffffff",
                              fontWeight: item.allergy ? "bold" : "normal",
                            }}
                          >
                            {pcpText}
                          </span>
                          <span
                            style={{
                              color: "white",
                              fontWeight: "normal",
                            }}
                          >
                            {suffix}
                          </span>
                        </span>
                      );
                    })
                  : t("dailySummary.NONE_EXPOSURE_TEXT")}
              </p>
            </div>
            <div className="exposure-category">
              <p>
                <span className="category-title">
                  {t("dailySummary.EXPOSURE_ACTIVITY_TEXT")}
                </span>
                  {Array.isArray(activity) && activity.length > 0
                    ? activity.map((item, i) => {
                        // const hasC = item.slice(-3) === "(C)" || item.slice(-4) === "(CR)";
                        const hasC = checkMarker(item, "C") || checkMarker(item, "CR");
                        const activityText =
                          hasC && item.length > 30
                            ? `${item.substr(0, 30)}...`
                            : item;

                        const isLast = i === activity.length - 1;
                        const suffix =
                          isLast && this.userLang === "1200000000001000022"
                            ? "."
                            : isLast && this.userLang !== "1200000000001000022"
                            ? "。"
                            : ", ";

                        return (
                          <span key={i}>
                            {activityText}
                            {suffix}
                          </span>
                        );
                      })
                    : t("dailySummary.NONE_EXPOSURE_TEXT")}{" "}
              </p>
            </div>
            <div className="exposure-category">
              <p>
                <span className="category-title">
                  {t("dailySummary.EXPOSURE_MEDICATION_TEXT")}
                </span>
                {Array.isArray(medication) && medication.length > 0
                  ? medication.map((item, i) => {
                      const contributedItem = item.is_contribute || false;
                      // const hasC = item.ingredient.slice(-3) === "(C)" || item.ingredient.slice(-4) === "(CR)";
                      const hasC = checkMarker(item.ingredient, "C") || checkMarker(item.ingredient, "CR");
                      const medicationText =
                        (contributedItem || hasC) && item.ingredient.length > 30
                          ? `${item.ingredient.substr(0, 30)}...`
                          : item.ingredient;

                      const isLast = i === medication.length - 1;
                      const suffix =
                        isLast && this.userLang === "1200000000001000022"
                          ? "."
                          : isLast && this.userLang !== "1200000000001000022"
                          ? "。"
                          : ", ";

                      return (
                        <span key={i}>
                          <span
                            style={{
                              color: item.allergy ? "#F44336" : "#ffffff",
                              fontWeight: item.allergy ? "bold" : "normal",
                            }}
                          >
                            {medicationText}
                          </span>
                          <span
                            style={{
                              color: "white",
                              fontWeight: "normal",
                            }}
                          >
                            {suffix}
                          </span>
                        </span>
                      );
                    })
                  : t("dailySummary.NONE_EXPOSURE_TEXT")}
              </p>
            </div>
            <div className="exposure-category">
              <p style={{ fontStyle: "italic" }}>
                <span className="category-title">
                  {t("dailySummary.EXPOSURE_LOCATION_TEXT")}
                </span>

                {Array.isArray(location) && location.length > 0 ? (
                  location.map((item, i) => {
                    const hasEnvData = Array.isArray(item.data) && item.data.length > 0;
                    // const isCustom =
                    //   item.name.slice(-3) === "(C)" ||
                    //   item.name.slice(-4) === "(CR)" ||
                    //   item.name.slice(-3) === "..." ||
                    //   item.is_custom;

                    const isCustom =
                      checkMarker(item.name, "C") ||
                      checkMarker(item.name, "C") ||
                      item.name.slice(-3) === "..." ||
                      item.is_custom;

                    const locationName =
                      item.name.length > 30
                        ? `${item.name.substr(0, 30)}...`
                        : item.name;

                    const dataSeparator = hasEnvData
                      ? " - "
                      : !isCustom
                      ? ` - ${this.props.t("dailySummary.AVAILABLE_SOON")}`
                      : "";

                    const isLast = i === location.length - 1;
                    const suffix =
                      isLast && this.userLang === "1200000000001000022"
                        ? "."
                        : isLast && this.userLang !== "1200000000001000022"
                        ? "。"
                        : ", ";

                    return (
                      <span key={i}>
                        <span>
                          {locationName}
                          {dataSeparator}
                        </span>

                        {hasEnvData &&
                          item.data.map((item_data, j) => (
                            <span key={j}>
                              <span
                                style={{
                                  color: item_data.allergy ? "#F44336" : "#ffffff",
                                  fontWeight: item_data.allergy ? "bold" : "normal",
                                }}
                              >
                                {item_data.title}: {item_data.value}
                                {item_data.unit}
                              </span>
                              <span
                                style={{
                                  color: "white",
                                  fontWeight: "normal",
                                }}
                              >
                                {j === item.data.length - 1 ? "" : "; "}
                              </span>
                            </span>
                          ))}

                        <span
                          style={{
                            color: "white",
                            fontWeight: "normal",
                          }}
                        >
                          {suffix}
                        </span>
                      </span>
                    );
                  })
                ) : (
                  <span>
                    {this.props.t("dailySummary.NONE_EXPOSURE_TEXT")}
                  </span>
                )}

              </p>
            </div>
          </div>
        </div>

        {/* nutrient section area */}
        <h6 className="section-title">
          {t("dailySummary.NUTRIENTS_SECTION_TITLE")}
        </h6>

        <div
          className={`grayList ingredient-list`}
          style={{
            flex: 1,
            backgroundColor: "black",
            borderColor: "#5c5c5c",
            height: "100%",
            padding: "1.5px 0.5rem",
          }}
          ref={this.ing}
        >
          {nutritionsList &&
            nutritionsList.map((item, i) => {
              let titleClass = item.bold
                ? "nutritionsItemTitle special"
                : "nutritionsItemTitle";
              let pointerClass = item.bold
                ? "nutritionsItemAmount special"
                : "nutritionsItemAmount";
              if (item.ind == 1) {
                titleClass += " subNut";
              }
              let desc = `${item.name}`;
              return (
                <div className="nutritionsItem" key={i}>
                  <div className={titleClass}>{desc}</div>
                  <div className={pointerClass}>
                    {item.sum || 0}
                    {item.sum > 0 ? item.symbol : ""}
                  </div>
                  <div className="percentageContainerArea">
                    <div
                      className="percentageContainer"
                      style={{
                        backgroundColor:
                          item.percentage == "N/A" ? "#5c5c5c" : "black",
                        border: "0.5px solid #5c5c5c",
                      }}
                    >
                      <div
                        className={`percentagePointer ${i < 10 ? "special" : ""
                          }`}
                        style={{
                          width: `${item.percentage != "N/A" ? item.percentage : 0
                            }%`,
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className="nutritionsItemPercentage"
                    style={{ color: "white" }}
                  >

                    {item.percentage}
                    {item.percentage != "N/A" ? "%" : ""}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  }
}

DailyInputSummary = translate("translations")(DailyInputSummary);

const mapStateToProps = (state) => ({
  ...state.dailySummary,
});

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ ...dailyInputSummaryActions }, dispatch);

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(DailyInputSummary);



// WEBPACK FOOTER //
// ./src/pages/DailyInputSummary.js